import { Typography } from '@mui/material';
import type { Currency, PromotionInput } from '@weft/types';
import { isEmptyArray } from '@weft/utils';
import React from 'react';
import { AddIcon } from '../../../../../../../components/icons/AddIcon';
import { PromotionChargesEditTable } from '../../../PromotionChargesEditTable/PromotionChargesEditTable';
import { AddItemMenuButton } from '../../create-plan-page-tabs-components/AddItemMenuButton';
import { EmptyTab } from '../../create-plan-page-tabs-components/EmptyTab';
import { PromotionsChargesMenuItems } from './promotion-charges-tab-content-components/PromotionsChargesMenuItems';

type PromotionChargesTabContentProps = {
  promotions: PromotionInput[];
  currency: Currency;
};

export const PromotionChargesTabContent: React.FC<PromotionChargesTabContentProps> = ({ promotions }) => {
  if (isEmptyArray(promotions)) {
    return (
      <EmptyTab
        title="Credits & Discounts"
        description={(
          <p>
            <span>Add credits and discounts to match</span>
            <br/>
            <span> your customers terms.</span>
          </p>
        )}
      >
        <AddItemMenuButton cta={
          <span className="flex items-center gap-x-2">
            <AddIcon fill="white"/>
            <span>Add Promotions</span>
          </span>
        }
        >
          <PromotionsChargesMenuItems/>
        </AddItemMenuButton>
      </EmptyTab>
    );
  }

  return (
    <div className="flex w-full flex-col gap-y-4">
      <div className="flex items-center justify-between">
        <Typography className="text-base font-medium">Promotions</Typography>

        <AddItemMenuButton
          className="bg-[#EAEEFC] text-[#458FFF]"
          cta={<span className="flex items-center gap-x-2">
            <AddIcon/>
            <span>Add Item</span>
          </span>}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <PromotionsChargesMenuItems/>
        </AddItemMenuButton>
      </div>

      <PromotionChargesEditTable promotions={promotions}/>
    </div>
  );
};